<ncp-table #diagnosticTests [(options)]="options"></ncp-table>
